import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';


@Component({
  selector: 'ppl-access-blocked',
  standalone: false,
  templateUrl: './access-blocked.component.html',
  styleUrl: './access-blocked.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessBlockedComponent {
  @Input() message: string;
  @Input() actionVisible = false;
  @Input() actionLabel: string;

  @Output() action = new EventEmitter();

  defaultMessage = $localize`:@@AuthAccessBlockedDefaultMessage:In accordance with your company's security policy, access is blocked from your current location.`;

  onAction() {
    this.action.emit();
  }
}
